import axios from 'axios';
import { createRequestHook } from '@clover-util/use-request';
import { getCloverApiHostname } from 'util/Environment';

export const LOGIN_TYPE = 'CWO_WEB';
export const CUST_AUTH_BASE_URL = `${getCloverApiHostname()}/customerauth`;

const customerAuthAxiosInstance = axios.create({
  baseURL: CUST_AUTH_BASE_URL,
});

export const useCustomerAuthRequest = createRequestHook(() => customerAuthAxiosInstance);
